import { Action } from 'redux';
import { GetUserNotifications, GetUserNotificationsSucceeded, GetUserNotificationsFailed } from '../../../app/actions/AppActionTypes';
import { IUserNotification } from '@tableau/user-notifications-client-core';
import { isActionFactory } from '../../../app/actions/isActionFactory';

export interface GetUserNotificationsAction extends Action { }

export interface GetUserNotificationsSucceededAction extends Action {
    notifications: _.Dictionary<IUserNotification<any>>;
}

export interface GetUserNotificationsFailedAction extends Action { }

export function getUserNotificationsAction(): GetUserNotificationsAction {
  return {
    type: GetUserNotifications,
  };
}

export function getUserNotificationsSucceededAction(notifications: _.Dictionary<IUserNotification<any>>): GetUserNotificationsSucceededAction {
  return {
    type: GetUserNotificationsSucceeded,
    notifications: notifications
  };
}

export function getUserNotificationsFailedAction(): GetUserNotificationsAction {
  return {
    type: GetUserNotificationsFailed,
  };
}

export const isGetUserNotificationsAction = isActionFactory<GetUserNotificationsAction>(GetUserNotifications);

export const isGetUserNotificationsSucceededAction = isActionFactory<GetUserNotificationsSucceededAction>(GetUserNotificationsSucceeded);

export const isGetUserNotificationsFailedAction = isActionFactory<GetUserNotificationsFailedAction>(GetUserNotificationsFailed);